import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../services/authentication/authentication.service';

export const tokenInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthenticationService);
  const tokenApi = authService.tokenSignal() ?? '';

  //console.log('TokenInterceptor - Token API:', tokenApi);

  if ( tokenApi && req.url.includes(environment.apiUrl)) {
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${tokenApi}`,
      },
    });
  return next(clonedRequest);

  }

  return next(req);
};
